module.exports = __webpack_public_path__ + "img/马蜂窝_03.a4c8ecc5.jpg";